import React from 'react';
import { graphql } from 'gatsby';

import BlockWorldSectionDS from 'design-system/src/components/organisms/BlockWorldSection';

import { getSrc } from '../../utils/media';

export default function BlockWorldSection({ badges, ...props }: any) {
    return (
        <BlockWorldSectionDS
            badges={badges?.length ? badges.map(getSrc).filter(Boolean) : []}
            {...props}
        />
    );
}

export const query = graphql`
    fragment DatoCmsBlockWorldSection on DatoCmsBlockWorldSection {
        badges {
            ...SourceMedia
            gatsbyImageData(height: 112, placeholder: NONE)
        }
        title
        text
        rating
        ratingLink {
            ...Button
        }
        countriesByMw {
            code
            country
            mw
            mwDisplay
        }
    }
`;
